module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("角色管理")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "warp-main",
    attrs: {
      "span": 24,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "角色名"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "v-if": true
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddDialog
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.role,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleName",
      "label": "角色名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleSign",
      "label": "角色编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "启用状态",
      "formatter": _vm.statusFommater
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgName",
      "label": "所属机构"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.orgId != 0) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.delBook(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addFormTitle,
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      },
      "close": _vm.dialogClose
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "角色名"
    },
    model: {
      value: (_vm.addForm.data.roleName),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "roleName", $$v)
      },
      expression: "addForm.data.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色编码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "角色编码"
    },
    model: {
      value: (_vm.addForm.data.roleSign),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "roleSign", $$v)
      },
      expression: "addForm.data.roleSign"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属单位"
    }
  }, [_c('TreeSelect', {
    ref: "treeSelect",
    attrs: {
      "props": _vm.props,
      "options": _vm.orgList,
      "value": _vm.valueId,
      "clearable": _vm.isClearable,
      "accordion": _vm.isAccordion
    },
    on: {
      "getValue": function($event) {
        return _vm.getValue($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "备注"
    },
    model: {
      value: (_vm.addForm.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "remark", $$v)
      },
      expression: "addForm.data.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "启用状态"
    },
    model: {
      value: (_vm.addForm.data.status),
      callback: function($$v) {
        _vm.$set(_vm.addForm.data, "status", $$v)
      },
      expression: "addForm.data.status"
    }
  }, _vm._l((_vm.statusSelect), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限"
    }
  }, [_c('TreeGrid', {
    ref: "roleTreeGride",
    staticStyle: {
      "height": "450px"
    },
    attrs: {
      "data": _vm.menuData,
      "checkbox": true,
      "idField": "id",
      "treeField": "name"
    }
  }, [_c('GridColumn', {
    attrs: {
      "field": "name",
      "title": "名称"
    }
  }), _vm._v(" "), _c('GridColumn', {
    attrs: {
      "field": "url",
      "title": "地址"
    }
  }), _vm._v(" "), _c('GridColumn', {
    attrs: {
      "field": "type",
      "title": "类型"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addForm.submit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ae643c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/role/list.vue
// module id = 1158
// module chunks = 2